<template>
<div>
  <div id="progress"></div>
</div>
</template>

<script>
import echarts from 'echarts'
import { ListProgressBarData } from '@/api/stat'

export default {
  name: 'progress-stat',
  created: function () {
    this.init()
  },
  methods: {
    init: function () {
      const id = this.$route.params.id
      ListProgressBarData(id).then(async res => {
        this.drawProgress(res)
      })
    },
    drawProgress: function (res) {
      var opts = {
        width: 'auto',
        height: (res.sites.length * 60 + 60) + 'px'
      }
      this.charts = echarts.init(document.getElementById('progress'), 'light', opts)
      var options = {
        title: {
          text: '各中心入组进度',
          x: 'left'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: res.statuses
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        yAxis: {
          type: 'category',
          data: res.sites
        },
        xAxis: {
          type: 'value'
        },
        series: res.series
      }
      this.options = options
      this.charts.setOption(options)
    }
  }
}
</script>
